import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';



// IMPORT GUARD FILES

import { AuthGuard } from '../../auth.guard';
import { ModuleGuard } from '../../permission.guard';
import { Role } from '../../_models/role';
import { Permission } from '../../_models/permission';


// IMPORT LEARNER MODULE COMPONENTS
import { MainLearnerComponent } from './main-learner.component';
import { LearnersComponent } from '../learners.component';
import { LearnerDashboardComponent } from '../learner-dashboard/learner-dashboard.component';
import { SingleLearnerComponent } from '../single-learner/single-learner.component';
import { LearnerReadingMaterialComponent } from '../learner-reading-material/learner-reading-material.component';
import { LearnerAllotmentTileComponent } from '../learner-allotment-tile/learner-allotment-tile.component';
import { ExamsResultsComponent } from '../exams-results/exams-results.component';
import { LearnerSubmissionComponent } from '../learner-submission/learner-submission.component';
import { PortfolioPolicyComponent } from '../portfolio-policy/portfolio-policy.component';


const routes: Routes = [
  {
    path: '',
    component: MainLearnerComponent,
    children: [
      {
        path: 'learners/:jobid',
        component: LearnersComponent,
        canActivate: [AuthGuard, ModuleGuard],
        data: { roles: [Role.Trainer, Role.Admin, Role.Mp, Role.IQA], permission: [Permission.TrainingJob] }
      },
      {
        path: 'view/:id',
        component: LearnerDashboardComponent,
        canActivate: [AuthGuard],
      },
      // {
      //   path: 'single-learner/:id',
      //   component: SingleLearnerComponent,
      //   canActivate: [AuthGuard],
      // },
      {
        path: 'readingMaterial/:id',
        component: LearnerReadingMaterialComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'allotment/:id',
        component: LearnerAllotmentTileComponent,
        canActivate: [AuthGuard],
      },
      // {
      //   path: 'exam-result/:jobid',
      //   component: ExamsResultsComponent,
      //   canActivate: [AuthGuard],
      // },
      // {
      //   path: 'learner/allotment/:id',
      //   component: LearnerSubmissionComponent,
      //   canActivate: [AuthGuard],
      // },
      // {
      //   path: 'portfolio-policy',
      //   component: PortfolioPolicyComponent
      // },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainLearnerRoutingModule { }
